import { render, staticRenderFns } from "./LiveDate.vue?vue&type=template&id=e1633354&"
import script from "./LiveDate.vue?vue&type=script&lang=js&"
export * from "./LiveDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports